module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_bbs_play.2bc93.png";